export class Message
{
    public Id = "";
    public Body: any;
}
